export const SessionTimeout = "Your session has expired! Please log in again";
